import { ENVIRONMENT, Environment } from '@v2/environment/environment';
import { provideDiTokenValue } from '@v2/utilities/di/di-token';
import { HttpHeaders, HttpOptions } from '../types';

export type DeviceApiType = 'mobile' | 'web';

export class CpBpApiConfig {
  constructor(private _environment: Environment) {}

  public getDeviceKind(): DeviceApiType {
    if (this._environment.device === 'mobile-web') {
      return 'mobile';
    }

    return 'web';
  }

  public getHeaders(): HttpHeaders {
    const apiLanguage: string = this._environment.language;
    return {
      'Content-Type': 'application/json',
      'Accept-Language': `${apiLanguage},${apiLanguage};q=0.5`,
      'Content-language': apiLanguage
    };
  }

  public getUserHeaders(): HttpHeaders {
    const apiLanguage: string = this._environment.language;
    return {
      'Accept-Language': `${apiLanguage}-${apiLanguage.toUpperCase()},${apiLanguage}`,
      'x-translation-lang': apiLanguage,
      'Content-language': apiLanguage
    };
  }

  public getUserAuthOptions(): HttpOptions {
    //const csrfToken: string | undefined = await this._getCsrfToken();
    return {
      credentials: 'include',
      headers: {
        device: this.getDeviceKind(),
        //...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
        ...this.getUserHeaders()
      }
    };
  }

  public getBpOptions(): HttpOptions {
    return {
      headers: {
        ...this.getHeaders()
      }
    };
  }

  public getBpAuthOptions(): HttpOptions {
    return {
      credentials: 'include',
      headers: {
        ...this.getHeaders()
      }
    };
  }
}

export function provideCpBpApiConfig(): CpBpApiConfig {
  return new CpBpApiConfig(provideDiTokenValue(ENVIRONMENT));
}
